<template>
  <div class="customAccordion">
    <v-expansion-panels
        v-model="panel"
        multiple
    >
      <v-expansion-panel
          v-for="(item,i) in items"
          :key="i"
      >
        <v-expansion-panel-header>{{ item.title }}</v-expansion-panel-header>
        <v-expansion-panel-content>
          {{ item.descr }}
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
export default {
  props: {
    items: String | Number | Boolean | Object | Array,
  },
  name: "accordions",
  data() {
    return {
      panel: [],
      // items: [
      //   {
      //     title: "Re-clouse (реклоуз) эффект",
      //     descr: "Возможность повторного приклеивания верхней пленки к упаковке. Применяется при упаковке нарезанной порционной продукции, сыра, мясных деликатесов",
      //   },
      //   {
      //     title: "Высокий барьер",
      //     descr: "На основе EVOH, проницаемость по О2 – 9,0 см3/м2/24 ч/атм, для увеличения срока хранения свежего мяса, рыбы и птицы; колбасных изделий и мясных деликатесов; созревших сыров",
      //   },
      //   {
      //     title: "Анти-фог эффект",
      //     descr: "Нанесение специального покрытия, снижающего поверхностное натяжение пленки. Данное покрытие не позволяет каплям влаги оседать на поверхности пленки изнутри упаковки. Образующиеся капли скатываются по бокам пленки, таким образом упакованный продукт всегда остается виден потребителю",
      //   },
      //   {
      //     title: "Some property",
      //     descr: "Some descr descr descr descr descr descr descr descr descr descr descr descr descr descr descr descr descr descr descr descr descr descr descr descr descr descr descr descr descr descr descr descr",
      //   },
      // ],
    };
  },
  methods: {},

};
</script>

<style lang="scss">
@import "../../theme/_variable.scss";

.customAccordion {
  & i.v-icon.notranslate.mdi{
    color: #F55640 !important;
  }
  & .v-expansion-panel-content__wrap,
  & .v-expansion-panel-header {
    padding: 0;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 100%;
    color: #F55640;
    font-family: "MuseoSansCyrl-700";
  }

  & .v-expansion-panel::before {
    box-shadow: none;
  }

  & .v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile) > .v-expansion-panel--active {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    padding-bottom: 12px;
  }
  & .v-expansion-panel--active:not(:first-child),
  & .v-expansion-panel--active + .v-expansion-panel {
    margin-top: 0;
  }
}

</style>
